import React from 'react'
import Tips from './Tips'
import SecondTips from './SecondTips'
import Navbar from '../Navbar'

function ManageTips() {
    return (
        <>
        <Navbar/>
        <Tips/>
        <SecondTips/>
        </>
    )
}

export default ManageTips
